import React from 'react'
import moment from 'moment'
import { Link, Text } from 'src/ui'
import { VStack } from '@chakra-ui/react'

const METABASE_REPORT_URL = `https://metabase.bushelops.com/dashboard/607-esign-billing-dashboard?month_%28any_day_in_a_month_shows_data_for_entire_month%29=${moment()
  .startOf('month')
  .format('YYYY-MM-DD')}`

const EsignReport = () => {
  return (
    <VStack px={8}>
      <Text fontWeight="bold" mb={2}>
        This page has moved to a Metabase report.
      </Text>
      <Link href={METABASE_REPORT_URL} isExternal color="blue.500">
        View the eSign billing dashboard
      </Link>
    </VStack>
  )
}

export default EsignReport
